@if (!initializing && rows?.length > 0) {
    <div class="row-r document-processing-page">
        <div [ngClass]="{'show-overlay': showOverlay}">
            <div class="document-processing-overlay">
            </div>
        </div>
        <!-- These will need to be changed once we introduce the resizable directive -->
        <section class="d-flex"
                 ws-resizable
                 [rFlex]="true"
                 [rMinWidth]="400"
                 rDragAxis="x"
                 rDragPosition="right">
            <div class="d-flex flex-wrap flex-grow-1 overflow-auto">
                <!-- Quick Search -->
                <!-- Data Entry -->
                @if (!entityIsMapped) {
                    <document-processing-search class="mx-2"
                                                [currentDocument]="currentRow.intakeDocumentInfo"
                                                [showCriteria]="showCriteria"
                                                [criteria]="criteria"
                                                [resultTypes]="resultTypes"
                                                [attachmentTypeId]="currentRow.intakeDocumentInfo.attachmentType.attachmentTypeID"
                                                (searchResultSelected)="searchResultSelected($event)">
                    </document-processing-search>
                }
                @if (currentRow && entityIsMapped) {
                    <div class="mx-2" style="width: 500px">
                        <entity-panel [currentRow]="currentRow"
                                      [entityDetails]="entityDetails"
                                      [selectedEntity]="selectedEntity"
                                      [revisionInfo]="revisionInfo"
                                      [loadingRevisionData]="loadingRevisionData"
                                      [warnOnEntityReload]="warnOnEntityReload"
                                      (setDirty)="setDirty($event)"
                                      (forceReloadEntity)="forceReloadEntity($event)"
                                      [associatedEntityMissing]="associatedEntityMissing"
                                      (loadQuickSearch)="loadQuickSearch()">
                        </entity-panel>
                    </div>
                }
                @if (!associatedEntityMissing && currentRow && entityIsMapped) {
                    <processing-entity-edit class="mx-2"
                                            (warnOnEntityReloadChanged)="warnOnEntityReloadChanged($event)"
                                            [firstEncounterSavedCallback]="firstEncounterSavedCb"
                                            [setDirty]="setDirty"
                                            [entityIdentifier]="selectedEntity"
                                            [intakeDocumentInfo]="currentRow.intakeDocumentInfo"
                                            [dataEntryJson]="currentRow.intakeDocumentInfo.intakeItem.entryJSON"
                                            [attachmentId]="currentRow.intakeDocumentInfo.attachmentID"
                                            [dataEntryJsonHandler]="dataEntryJSONHandler"
                                            [validationHandler]="validationHandler"
                                            [attachmentTypeId]="currentRow.intakeDocumentInfo.attachmentType.attachmentTypeID"
                                            [parcelId]="entityDetails.parcel?.entityId"
                                            [parcelAcctNum]="entityDetails.parcel?.text"
                                            [siteName]="entityDetails.site?.text"
                                            [intakeBatchItemNumber]="getIntakeBatchItemNumber()"
                                            [companyName]="entityDetails.subsidiaryCompany?.text"
                                            [companyId]="entityDetails.subsidiaryCompany?.entityId || entityDetails.topLevelCompany?.entityId"
                                            [searchAnticipated]="criteria.anticipated"
                                            [associatedEntityChanged]="associatedEntityChanged"
                                            [stateId]="entityDetails.extendedData.collectorStateID"
                                            (billRevisionChangedX)="billRevisionChanged($event)"
                                            [parcelChanges]="currentRow.intakeDocumentInfo.parcelChanges"
                                            [collectorId]="entityDetails.collector?.entityId">
                    </processing-entity-edit>
                }
            </div>
        </section>
        <section>
            <!-- Document Preview -->
            <!--<h3 class="text-center">Document Preview</h3>-->
            @if (currentRow) {
                <div class="h-100">
                    <div class="h-100">
                        @if (!currentRow.fileError && currentRow.intakeDocumentInfo.attachmentUrl) {
                            <file-viewer [file]="currentRow.intakeDocumentInfo.file"
                                         class="h-100">
                            </file-viewer>
                        }
                        @if (currentRow.fileError) {
                            <div class="download-preview-error">
                                Cannot show file due to processing error
                            </div>
                        }
                        @if (!(currentRow.fileError || currentRow.intakeDocumentInfo.fileInfo.previewSupported)) {
                            <div class="pt-3 d-flex justify-content-center">
                                <span class="anchor-style" (click)="downloadAttachment()">Click to download or view in native
                                    application.</span>
                            </div>
                        }
                    </div>
                </div>
            }
        </section>
    </div>
    <div class="action-footer d-flex justify-content-between w-100 py-3">
        <div class="d-flex ps-4 align-items-center">
            <div helpTooltip [tooltipText]="validationMessage" [helpDisabled]="!validationMessage">
                <button class="ace-btn btn-primary btn-danger btn-sm"
                        (click)="openDismissModal()"
                        [disabled]="disableEntryButtons">
                    Exception
                </button>
            </div>
            <div helpTooltip [tooltipText]="validationMessage" [helpDisabled]="!validationMessage">
                <button class="ace-btn btn-primary btn-sm"
                        (click)="saveEntityDetails()"
                        [disabled]="disableEntryButtons">
                    Save
                </button>
            </div>
            <div>
                <button class="ace-btn btn-primary btn-sm"
                        (click)="launchDuplicateModal()"
                        [disabled]="disableEntryButtons">
                    Duplicate
                </button>
            </div>
            <div helpTooltip [tooltipText]="validationMessage" [helpDisabled]="!validationMessage">
                @if (!associatedEntityMissing && !associatedEntityChanged && (selectedEntity || currentRow.intakeDocumentInfo.intakeItem.entityID)) {
                    <button class="ace-btn btn-secondary btn-sm"
                            (click)="completeTask()"
                            [disabled]="disableEntryButtons">
                        {{ completeButtonLabel }} and Show Next
                    </button>
                }
            </div>
            @if (dismissModalValidationOpen || saveEntityValidationOpen || completeValidationOpen) {
                <div>
                    <span class="text-danger">{{ validationMessage }}</span>
                </div>
            }
        </div>
        <div class="action-buttons-row d-flex align-items-center">
            @if (currentRow) {
                <span>
                    <label class="mb-0">Item #:</label>
                    <span class="ms-2">{{ currentRow.intakeDocumentInfo.intakeBatch.batchNumber }}
                        #{{ currentRow.intakeDocumentInfo.intakeItem.itemNumber }}
                        @if (currentRow.intakeDocumentInfo.intakeItem.duplicateNumber) {
                            <span>_{{ currentRow.intakeDocumentInfo.intakeItem.duplicateNumber }}</span>
                        }
                    </span>
                </span>
            }
            <span class="ms-4 d-flex align-items-center">
                <label class="mb-0">Document Type:</label>
                <ws-select class="d-inline-block ms-2"
                           [ngModel]="currentRow.intakeDocumentInfo.attachmentType.attachmentTypeID"
                           valueProperty="attachmentTypeID"
                           labelProperty="attachmentTypeName"
                           [options]="documentTypeList | sortBy:'attachmentTypeName'"
                           [disabled]="!showCriteria || entityIsMapped || disableEntryButtons"
                           (ngModelChange)="documentTypeChanged($event)">
                    <option></option>
                </ws-select>
            </span>
            @if (currentRow.intakeDocumentInfo.intakeItem.exceptionStatusID) {
                <span class="ms-4">
                    <label class="mb-0">Exception Status:</label>
                    <span> {{ ProcessingExceptionStatusText[currentRow.intakeDocumentInfo.intakeItem.exceptionStatusID] }}</span>
                </span>
            }
        </div>
        <div class="d-flex align-items-center">
            <entity-comments [hasComments]="currentRow.intakeDocumentInfo.hasComments"
                             buttonClass="icon-button m-0"
                             [getModalData]="getCommentsModalData">
            </entity-comments>
            <button (click)="onSkipClick()"
                    class="ace-btn btn-sm btn-primary"
                    [disabled]="disableSkip || disableEntryButtons">
                Skip@if (currentRowIndex < rows?.length - 1) {
                <span>/Next</span>
            }
            </button>
            <div class="btn-group dropup ms-2" [dropup]="true" dropdown>
                <button type="button" class="ace-btn btn-sm btn-secondary dropdown-toggle"
                        dropdownToggle
                        [disabled]="disableEntryButtons">
                    Pop-out
                    <span class="caret"></span>
                </button>
                <ul *dropdownMenu
                    role="menu"
                    class="dropdown-menu">
                    <li role="menuitem">
                        <span class="dropdown-item clickable" (click)="popoutPreview(true)">Dynamic</span>
                    </li>
                    <li role="menuitem">
                        <span class="dropdown-item clickable" (click)="popoutPreview(false)">Static</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
}
@if (!initializing && rows?.length === 0) {
    <div class="empty-document-page">
        <div class="mb-3">
            <h3>No results found</h3>
        </div>
        <div>
            <a class="ace-btn btn-primary" anchor-route [sref]="{ target: 'actionview' }">Back to Action Views</a>
        </div>
    </div>
}
